// Map a raw setup error into an actionable remedy. Remedies name the BUTTON
// that fixes them: GitHub creds come from "Connect GitHub", so telling people
// to edit a token sends them hunting for a field that no longer exists.
export const humanizeSetupError = (raw: string): string => {
  const lower = raw.toLowerCase();
  if (lower.includes('timed out')) {
    return raw; // already phrased as a retryable timeout
  }
  // Already formatted as a per-tool list with install commands, and it is
  // multi-line on purpose — pass it through instead of truncating to line one.
  if (lower.includes('missing required tools')) {
    return raw;
  }
  if (lower.includes('command not found')) {
    return `A tool the runner needs isn’t installed on that machine. ${raw.split('\n')[0]}`;
  }
  if (lower.includes('no github token')) {
    return 'GitHub isn’t connected. Press “Connect GitHub” above, approve the code on github.com, then Try Again.';
  }
  if (lower.includes('no repository url')) {
    return 'No repository chosen. Connect GitHub, pick a repository from the dropdown, Save, then Try Again.';
  }
  // The expired/revoked-credential case. Reconnecting mints a fresh token and
  // replaces the stored one, so that's the fix — not editing anything by hand.
  if (
    lower.includes('authentication failed') ||
    lower.includes('invalid username or token') ||
    lower.includes('403')
  ) {
    return 'GitHub rejected the stored credential — it’s expired or was revoked. Press “Connect GitHub” above to sign in again, then Try Again.';
  }
  if (lower.includes('repository not found') || lower.includes('not found')) {
    return 'That repository couldn’t be reached. Re-pick it from the dropdown (Connect GitHub first if the list is empty), Save, then Try Again.';
  }
  if (lower.includes('could not resolve host')) {
    return 'No network from the runner machine. Check its connection, then Try Again.';
  }
  return raw.split('\n')[0].slice(0, 240);
};
